module.exports = __webpack_public_path__ + "static/hk-tower-915ff7eaf48a1243354961a0ad17575d.jpg";